import React, { useState } from 'react';
import cx from 'classnames';
import { GridColumn, GridRow } from 'app/layouts/grid';
import { ConfigureAgent } from 'app/member/modules/lead/config';
import styles from './config.module.css';
import { BasicInfoSection } from 'app/shared/info-section/basic';
import { MessageConfig } from './message';
import { LabelConfig } from './label';

const NAV_ITEMS = [
  { key: 'leads', title: 'Lead Gen' },
  { key: 'messages', title: 'Messages' },
  { key: 'labels', title: 'Labels' }
];

export const CustomersConfigBoard = () => {
  const [active_section, setActiveSection] = useState('leads');

  return (
    <div className={styles.body}>
      <GridRow num_of_columns={5}>
        <GridColumn span={1}>
          <BasicInfoSection className={styles.navWrapper}>
            <div className={styles.nav}>
              {NAV_ITEMS.map(({ key, title }) => (
                <div
                  key={key}
                  className={cx(styles.navItem, {
                    [styles.navItemActive]: active_section === key
                  })}
                  onClick={() => setActiveSection(key)}
                >
                  {title}
                </div>
              ))}
            </div>
          </BasicInfoSection>
        </GridColumn>
        <GridColumn span={3}>
          {active_section === 'leads' && (
            <BasicInfoSection>
              <ConfigureAgent />
            </BasicInfoSection>
          )}
          {active_section === 'messages' && <MessageConfig />}
          {active_section === 'labels' && <LabelConfig />}
        </GridColumn>
        <GridColumn />
      </GridRow>
    </div>
  );
};
